









































































import router from "@/router/router";
import { store } from "@/store/store";
import Vue from "vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import MabBar from "@/components/Map/MapBar.vue";
import { Survey } from "@/store/modules/Survey/interface";
import InformationCard from "@/components/Page/SurveyDescription/InformationsCard.vue";
import SurveyDescriptionTable from "@/components/Table/SurveyDescription/SurveyDescriptionTable.vue";
import { PosteActionsTypes } from "@/store/modules/Poste/types";
import { FormType, IMapDataDefinition } from "@/types/types";
import TableComplement from "@/components/Table/Complement/TableComplement.vue";
import PosteDeleteModal from "@/components/Modal/SurveyDescription/PosteDeleteModal.vue";
import PosteCreateModal from "@/components/Modal/SurveyDescription/PosteCreateModal.vue";
import { Response_ } from "@/plugins/axios/response";
import Toast from "@/components/Modal/Toast/Toast.vue";
import { Poste } from "@/store/modules/Poste/interface";

interface SurveyDescriptionData {
  survey: Survey;
  should_display_create_modal: boolean;
  should_display_delete_modal: boolean;
  map_should_be_displayed: boolean;
  selected: Array<string>;
  loading: boolean;
  poste_id?: string;
  should_display_toast: boolean;
  toast: any;
}

export default Vue.extend({
  name: "SurveyDescription",
  components: {
    NavbarTitle,
    InformationCard,
    StandartCard,
    MabBar,
    SurveyDescriptionTable,
    TableComplement,
    PosteDeleteModal,
    PosteCreateModal,
    Toast
  },
  data(): SurveyDescriptionData {
    return {
      survey: store.getters.SURVEY_BY_ID[this.$route.query.surveyId as string],
      should_display_create_modal: false,
      should_display_delete_modal: false,
      map_should_be_displayed: false,
      selected: [],
      loading: false,
      poste_id: undefined,
      should_display_toast: false,
      toast: { type: "INFO", title: "", content: "" }
    };
  },
  async mounted() {
    await store.dispatch(PosteActionsTypes.LIST_POSTE_BY_SURVEY, this.survey._id);
    this.loading = false;
  },
  methods: {
    MoveToSurveyPage(): void {
      router.push({ path: "/surveys" });
    },
    mapDisplayToggle(): void {
      this.map_should_be_displayed = !this.map_should_be_displayed;
    },
    clearSelected(): void {
      this.selected = [];
    },
    onSelectChange(_ids: Array<string>): void {
      this.selected = _ids;
    },
    mapDatas(): Array<IMapDataDefinition> {
      const selected =
        this.selected.length !== 0
          ? this.selected
          : Object.entries(store.getters.POSTE_BY_ID)
              .map((poste) => (this.survey._id === poste[1].survey ? poste[0] : "undefined"))
              .filter((res) => res !== "undefined");
      return selected.map((poste_id) => {
        const poste = { ...store.getters.POSTE_BY_ID[poste_id] };
        return {
          ...poste,
          name: poste.name_poste,
          location: poste.real_location
        };
      });
    },
    shouldDisplayCreateModal(id?: string) {
      this.poste_id = id;
      this.should_display_create_modal = true;
    },
    shouldCloseCreateModal() {
      this.should_display_create_modal = false;
      this.poste_id = undefined;
    },
    shouldDisplayDeleteModal(id: string) {
      this.poste_id = id;
      this.should_display_delete_modal = true;
    },
    shouldCloseDeleteModal() {
      this.should_display_delete_modal = false;
      this.poste_id = undefined;
    },
    async onDelete(): Promise<Response_> {
      return store.dispatch(PosteActionsTypes.DELETE_POSTE, {
        survey_id: this.survey._id,
        poste_id: this.poste_id as string
      });
    },
    async onCreateOrModify(type: FormType, poste: Poste): Promise<Response_> {
      return type === FormType.CREATE ? this.onCreate(poste) : this.onUpdate(poste);
    },
    async onCreate(poste: Poste): Promise<Response_> {
      return store.dispatch(PosteActionsTypes.CREATE_POSTE, poste);
    },
    async onUpdate(poste: Poste): Promise<Response_> {
      return store.dispatch(PosteActionsTypes.UPDATE_POSTE, poste);
    },
    shouldDisplayToastNotification(toast_data: any): void {
      this.toast = toast_data;
      this.should_display_toast = true;
      setTimeout(this.shouldCloseToastNotification, 2000);
    },
    shouldCloseToastNotification(): void {
      this.should_display_toast = false;
    }
  }
});
